export default function programTab() {
  const selectors = document.querySelectorAll('.js-program-selector');
  const tabs = document.querySelectorAll('.js-program-tab');

  if (!selectors.length || !tabs.length) return;

  let currentIndex = 0;

  selectors.forEach((selector, index) => {
    selector.addEventListener('click', () => {
      if (currentIndex === index) return; // 同じタブをクリックした場合は何もしない

      // すべてのセレクターからis-activeを削除
      selectors.forEach(s => s.classList.remove('is-active'));
      // クリックされたセレクターにis-activeを追加
      selector.classList.add('is-active');

      // 現在のタブをフェードアウト
      const currentTab = tabs[currentIndex];
      currentTab.style.opacity = '0';

      setTimeout(() => {
        // すべてのタブを非表示
        tabs.forEach(tab => {
          tab.style.display = 'none';
          tab.style.opacity = '0';
        });

        // 新しいタブを表示してフェードイン
        if (tabs[index]) {
          tabs[index].style.display = 'block';
          setTimeout(() => {
            tabs[index].style.opacity = '1';
          }, 50);
        }

        currentIndex = index;
      }, 300);
    });
  });

  // 初期表示: 最初のタブのみ表示
  tabs.forEach((tab, index) => {
    tab.style.display = index === 0 ? 'block' : 'none';
    tab.style.opacity = index === 0 ? '1' : '0';
    tab.style.transition = 'opacity 0.3s ease';
  });
}
